import { useMountEffect } from '@react-hookz/web/esm';
import * as React from 'react';
import store from '../../../store';
import { previousValidationActions } from '../../../store/previousValidationSlice';

export const ValidationContext = React.createContext<
  { form: string } | undefined
>(undefined);
ValidationContext.displayName = 'ValidationContextPrimitive';
export function useValidationContext() {
  const context = React.useContext(ValidationContext);
  if (!context) throw new Error('No validation context!');
  return context;
}

const ValidationContextProvider = ({
  form,
  children,
}: {
  children: React.ReactNode;
  form: string;
}) => {
  const contextValue = React.useMemo(() => ({ form }), [form]);

  useMountEffect(() => {
    store.dispatch(previousValidationActions.init({ form }));
  });

  return (
    <ValidationContext.Provider value={contextValue}>
      {children}
    </ValidationContext.Provider>
  );
};

export default ValidationContextProvider;
